<template>
  <div class="app ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="chip" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4 mb-2" v-if="!edicao">Cadastro de Operador</div>

      <v-form ref="form">
        <v-row dense>
          <v-col cols="3">
            <v-switch v-model="form.active" label="Ativo" dense :disabled="permissaoVisualizar" />
          </v-col>
          <v-col cols="3">
            <v-switch v-model="form.ringinuse" label="Chamar quando ocupado" dense :disabled="permissaoVisualizar" />
          </v-col>
          <v-col cols="3">
            <v-switch v-model="form.autopause" label="Autopause" dense :disabled="permissaoVisualizar" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined dense type="number" label="Código" counter="10" v-model="form.numero"
              :disabled="desativado || permissaoVisualizar" :error-messages="numeroErrors"
              @input="$v.form.numero.$touch()" @blur="$v.form.numero.$touch()" />
          </v-col>
          <v-col>
            <v-text-field outlined dense label="Usuário" counter="20" v-model="form.usuario"
              :disabled="permissaoVisualizar" :error-messages="usuarioErrors" @input="$v.form.usuario.$touch()"
              @blur="$v.form.usuario.$touch()" />
          </v-col>
          <v-col>
            <v-text-field outlined dense label="Email" v-model="form.email" :disabled="permissaoVisualizar"
              :error-messages="emailErrors" @input="$v.form.email.$touch()" @blur="$v.form.email.$touch()" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field outlined dense label="Senha" v-model="form.senhaRamal"
              :type="show || permissaoVisualizar ? 'number' : 'password'" @click:append="show = !show"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :error-messages="senhaRamalErrors"
              :disabled="permissaoVisualizar" @input="$v.form.senhaRamal.$touch()"
              @blur="$v.form.senhaRamal.$touch()" />
          </v-col>
          <v-col cols="4">
            <v-text-field outlined dense label="Qtd. Ligações Simultâneas" type="number" v-model="form.maxlen"
              :disabled="permissaoVisualizar" :error-messages="maxlenErrors" @input="$v.form.maxlen.$touch()"
              @blur="$v.form.maxlen.$touch()" />
          </v-col>
          <v-col cols="4">
            <v-select outlined dense label="Departamento" v-model="form.departamento" :items="departamentos"
              :disabled="permissaoVisualizar" :error-messages="departamentoErrors"
              @input="$v.form.departamento.$touch()" @blur="$v.form.departamento.$touch()" />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="4">
            <v-select outlined multiple v-model="form.numeroRamaisPermitidosTelaOperador" :items="operadoresMonitor"
              dense label="Operadores Monitor">

              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.text }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ form.numeroRamaisPermitidosTelaOperador.length - 1 }}) </span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleOperadoresMonitor">
                  <v-list-item-action>
                    <v-icon :color="form.numeroRamaisPermitidosTelaOperador.length > 0 ? 'indigo darken-4' : ''">
                      {{ iconSelecionaTodos }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Selecionar Todos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>

            </v-select>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="2">
            <v-switch dense v-model="Queuebool" label="Fila" />
          </v-col>

        </v-row>

        <v-row v-for="n in qtdFilas" :key="`queue_${n}`" align="baseline" dense>
          <v-col cols="4" v-if="Queuebool == true">
            <v-select dense v-model="queueSelected[n - 1]" :items="filas" outlined label="Filas"
              :disabled="permissaoVisualizar" />
          </v-col>
          <v-col cols="2" v-if="Queuebool == true">
            <v-select dense v-model="prioritySelected[n - 1]" :items="priorities" outlined label="Prioridade"
              :disabled="permissaoVisualizar" />
          </v-col>
          <v-col cols="2" v-if="Queuebool == true">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small dark icon color="bluePcm" v-bind="attrs" v-on="on" @click="novaFila"
                  :disabled="permissaoVisualizar">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Nova Fila</span>
            </v-tooltip>
            <v-tooltip top v-if="n - 1 !== 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small dark icon color="darkRed" v-bind="attrs" v-on="on" @click="removeFila(n - 1)"
                  :disabled="permissaoVisualizar">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover Fila</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <DraggAndDrop dragname="Rotas" :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
          @dragUpdate="updateRotasGeral($event)" :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas" />
        <DraggAndDrop dragname="Rotas de Transferência"
          :valoresDisponiveisComboBox="rotasTransferencias.rotasTransferenciasDisponiveis"
          @dragUpdate="updateRotasTransferencia($event)"
          :opcoesSelecionadas="rotasTransferencias.rotasTransferenciasSelecionadas" />
        <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader"
          :disableSaveButton="permissaoVisualizar" />
        <div v-for="n in 3" :key="n">
          <v-divider vertical />
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters
  } from 'vuex'
  import {
    validationMixin
  } from 'vuelidate'
  import Snackbar from '@/componentes/Snackbar'
  import FixedButtons from '@/componentes/FixedButtons'
  import {
    registerVuexModule,
    formatarRota
  } from '@/utils/vuexUtils'
  import {
    obtainUserPermissions
  } from '@/utils/obtainUserPermissions'
  import {
    validateData,
    validateComputed
  } from '../_validates/validatesOperadores'
  import operadorHttpService from '../_services/operadorHttpService'
  import DraggAndDrop from '../_components/DraggAndDrop'
  import operadoresStore from '../_store'
  export default {
    name: 'CadastroOperador',
    props: {
      edicao: String,
      _id: String,
    },
    components: {
      Snackbar,
      FixedButtons,
      DraggAndDrop
    },
    mixins: [validationMixin],
    data: () => ({
      text: '',
      snackbar: false,
      showSkeleton: false,
      desativado: false,
      show: false,
      priorities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      qtdFilas: 1,
      queueSelected: [],
      prioritySelected: [],
      departamentos: [],
      operadoresMonitor: [],
      form: {
        numero: '',
        usuario: '',
        email: '',
        senhaRamal: '',
        senhaWeb: '',
        departamento: [],
        active: true,
        ringinuse: false,
        maxlen: 1,
        queues: [],
        rota: [],
        rotaTransferencia: [],
        numeroRamaisPermitidosTelaOperador: [],
        autopause: false,
      },
      filas: [],
      rotas: [],
      rotasTransferencia: [],
      pararLoader: {
        parar: false,
      },
      rotasTransferencias: {
        rotasTransferenciasDisponiveis: [],
        rotasTransferenciasSelecionadas: [],
      },
      rotasGerais: {
        rotasGeralDisponiveis: [],
        rotasGeralSelecionadas: [],
      },
      permissaoVisualizar: false,
      Queuebool: false,
    }),
    validations: {
      ...validateData,
    },
    computed: {
      ...validateComputed,
      ...mapGetters('cadastroOperadorModuleCallCenterStore', [
        'getOperador',
        'getRoutes',
        'getQueues',
        'getDepartamentos',
        'getOperadoresMonitor'
      ]),
      todosRamaisPermitidosSelecionados() {
        return this.form.numeroRamaisPermitidosTelaOperador.length === this.operadoresMonitor.length
      },
      algunsRamaisPermitidosSelecionados() {
        return this.form.numeroRamaisPermitidosTelaOperador.length > 0 && !this.todosRamaisPermitidosSelecionados
      },
      iconSelecionaTodos() {
        if (this.todosRamaisPermitidosSelecionados) {
          return 'mdi-close-box'
        } else if (this.algunsRamaisPermitidosSelecionados) {
          return 'mdi-minus-box'
        } else {
          return 'mdi-checkbox-blank-outline'
        }
      },
    },
    async created() {
      this.showSkeleton = true
      registerVuexModule(this.$store, 'cadastroOperadorModuleCallCenterStore', operadoresStore)
      await Promise.all([this.listarRotas(), this.listarFilas(), this.listarDepartamentos(),
        this.listarOperadoresMonitor()
      ])
      this.rotasTransferencias.rotasTransferenciasDisponiveis = [...this.getRoutes]
      this.rotasGerais.rotasGeralDisponiveis = [...this.getRoutes]
      this.operadoresMonitor = this.getOperadoresMonitor.ramais.map(item => {
        return {
          value: item.numero,
          text: item.usuario  
        }
      })
      this.filas = this.getQueues.map(fila => ({
        value: fila._id,
        text: fila.description
      }))
      this.departamentos = this.getDepartamentos.map(departamento => ({
        text: `${departamento.codigo} - ${departamento.description}`,
        value: departamento._id,
      }))
      if (this.edicao === 'true') {
        this.desativado = true
        this.form = Object.assign(this.getOperador, {
          departamento: this.getOperador.departamento._id
        })
        if (this.form.queues.length !== 0) {
          this.Queuebool = true;
        }
    
        if (typeof this.getOperador.ringinuse === 'undefined') {
          this.form.ringinuse = false
        } else {
          this.form.ringinuse = this.getOperador.ringinuse
        }
        const valuesRota = Object.values(this.getOperador.rota)
        const valuesRotaTransferencia = Object.values(this.getOperador.rotaTransferencia)
        valuesRota.forEach(rota => {
          const indexRotaGeral = this.rotasGerais.rotasGeralDisponiveis.findIndex(rotaGeral => rotaGeral._id ===
            rota)
          if (indexRotaGeral !== -1) {
            this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotaGeral])
          }
        })
        valuesRotaTransferencia.forEach(rotaTransferencia => {
          const indexRotaTransferencia = this.rotasTransferencias.rotasTransferenciasDisponiveis.findIndex(
            rota => rota._id === rotaTransferencia
          )
          if (indexRotaTransferencia !== -1) {
            this.rotasTransferencias.rotasTransferenciasSelecionadas.push(
              this.rotasTransferencias.rotasTransferenciasDisponiveis[indexRotaTransferencia]
            )
          }
        })
        this.queueSelected = this.getOperador.queues.map(fila => fila.queue)
        this.prioritySelected = this.getOperador.queues.map(fila => Number(fila.penalty))
        this.form.departamento = this.getOperador.departamento;
        if (this.getOperador.queues.length == 0) {
          this.qtdFilas = 1
        } else {
          this.qtdFilas = this.getOperador.queues.length
        }
      } else {
        this.prioritySelected[0] = 1
        this.rotasTransferencias.rotasTransferenciasSelecionadas = this.rotasGerais.rotasGeralDisponiveis.filter(
          rota => rota.default
        )
        this.rotasGerais.rotasGeralSelecionadas = this.rotasGerais.rotasGeralDisponiveis.filter(rota => rota.default)
      }
      const arrayPermissions = this.arrayPermissionsFromLocalStorage()
      if (arrayPermissions.includes(process.env.VUE_APP_CALLCENTER_CADASTRO_OPERADOR_VISUALIZAR_CONDICIONADO)) {
        this.permissaoVisualizar = true
      }
      this.showSkeleton = false
    },
    methods: {
      ...mapActions('cadastroOperadorModuleCallCenterStore', ['listarFilas', 'listarRotas', 'listarDepartamentos',
        'listarOperadoresMonitor'
      ]),
      ...obtainUserPermissions,
      cancelar() {
        this.$router.push({
          name: 'Operador'
        })
      },
      toggleOperadoresMonitor() {
        this.$nextTick(() => {
          if (this.todosRamaisPermitidosSelecionados) {
            this.form.numeroRamaisPermitidosTelaOperador.splice(0)
          } else {
            this.form.numeroRamaisPermitidosTelaOperador.splice(0)
            this.form.numeroRamaisPermitidosTelaOperador = this.operadoresMonitor.map(operador => operador.value)
          }
        })
      },
      async salvar() {
        this.pararLoader.parar = false
        if (!this.form.rota['1']) {
          this.text = 'Rota é obrigatória.'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        }
        if (!this.form.rotaTransferencia['1']) {
          this.text = 'Rota transferência é obrigatória.'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        }
       
      
        if (this.queueSelected.length > this.filas.length) {
          this.text = 'Não é possível repetir filas'
          this.pararLoader.parar = true
          this.snackbar = true
          return
        } else {
          let temChavesDuplicadas = new Set(this.queueSelected).size !== this.queueSelected.length
          if (temChavesDuplicadas) {
            this.text = 'Não é possível repetir filas'
            this.pararLoader.parar = true
            this.snackbar = true
            return
          }
        }
        this.$v.$touch()
        if (this.$v.$error) {
          this.$vuetify.goTo(1, {
            duration: 1000,
            easing: 'easeOutCubic'
          })
          this.pararLoader.parar = true
          return
        }
        this.form.queues.splice(0)
        if (this.Queuebool == true) {
          for (let i = 0; i < this.queueSelected.length; i++) {
            this.form.queues.push({
              queue: this.queueSelected[i],
              penalty: this.prioritySelected[i]
            })
          }
        }
        this.form.senhaWeb = this.form.senhaRamal
        this.form.departamento = this.getDepartamentos.find(departamento => (departamento._id == this.form
          .departamento))
        try {
          if (this.edicao === 'true') {
            await operadorHttpService.putOperador(this._id, this.form)
          } else {
            await operadorHttpService.postOperador(this.form)
          }
          this.$router.push({
            name: 'Operador'
          })
        } catch (error) {
          let key = Object.keys(error.response.data)
          this.text = error.response.data[key[0]]
          this.snackbar = true
          this.pararLoader.parar = true
        }
      },
      novaFila() {
        this.qtdFilas = this.qtdFilas + 1
        this.prioritySelected[this.qtdFilas - 1] = 1
      },
      removeFila(key) {
        this.qtdFilas = this.qtdFilas - 1
        this.queueSelected.splice(key, 1)
        this.prioritySelected.splice(key, 1)
      },
      updateRotasGeral(event) {
        this.form.rota = formatarRota(event)
      },
      updateRotasTransferencia(event) {
        this.form.rotaTransferencia = formatarRota(event)
      },
    },
  }
</script>

<style scoped>
  .app {
    background-color: var(--v-background-base);
  }
</style>